import { Endpoints } from './api-types'
import { POLYGON } from '../chain/polygon-mainnet'

const SUBGRAPH_ENDPOINT = POLYGON.THE_GRAPH_URL

export const reactEndpoints: Endpoints = {
  subgraph: SUBGRAPH_ENDPOINT,
}
